import React from 'react';
import { Box } from '@common-fe/common-fe';

import { PaymentMethod } from '@/modules/transaction/components/ReimburseMe/types/payment.types';

import PaymentMethodDescription from './PaymentMethodDescription';
import PaymentMethodIcon from './PaymentMethodIcon';
interface Props {
  isVerifiedDateVisible?: boolean;
  paymentMethod?: Partial<PaymentMethod>;
  paymentEmployeeFee?: string;
  hasPaymentEmployeeFee?: boolean;
  simplifyDesc?: boolean;
  hideIconBorder?: boolean;
  hideIcon?: boolean;
  showPlaidStatus?: boolean;
  hasAccountVerificationPendingMessage?: boolean;
}

export const PaymentMethodLabel: React.FC<Props> = ({
  paymentMethod,
  simplifyDesc,
  hideIconBorder,
  isVerifiedDateVisible = true,
  hideIcon,
  showPlaidStatus,
  paymentEmployeeFee,
  hasPaymentEmployeeFee,
  hasAccountVerificationPendingMessage,
}) => {
  const shouldShowIcon = !hideIcon;

  return (
    <Box
      data-testid="PaymentMethodLabel_container"
      direction="row"
      align="center"
    >
      {shouldShowIcon &&
        <PaymentMethodIcon paymentMethod={paymentMethod} hideIconBorder={hideIconBorder} />}
      <PaymentMethodDescription
        paymentMethod={paymentMethod}
        simplifyDesc={simplifyDesc}
        isVerifiedDateVisible={isVerifiedDateVisible}
        showPlaidStatus={showPlaidStatus}
        paymentEmployeeFee={paymentEmployeeFee}
        hasPaymentEmployeeFee={hasPaymentEmployeeFee}
        hasAccountVerificationPendingMessage={hasAccountVerificationPendingMessage}
      />
    </Box>
  );
};
